import { InputGroup, Form } from 'react-bootstrap';
import { MdDelete } from 'react-icons/md';
import { IconButton } from '@Components/IconButton';
import { WtoVariant } from '../wto-form-context';

interface VariantRowProps {
  variant: WtoVariant;
  index: number;
  readOnly: boolean;
  showDelete: boolean;
  onChange: (index: number, variant: WtoVariant) => void;
  onDelete: (index: number) => void;
}

export const VariantRow = ({
  variant,
  index,
  readOnly,
  showDelete,
  onChange,
  onDelete
}: VariantRowProps) => (
  <InputGroup>
    <InputGroup.Text>{index + 1}.</InputGroup.Text>
    <Form.Control
      className='variant-id'
      value={variant.variant_id || ''}
      placeholder='Variant ID'
      disabled={readOnly}
      onChange={e =>
        onChange(index, { variant_id: e.target.value, variant_url: variant.variant_url })
      }
    />
    <Form.Control
      className='variant-url'
      value={variant.variant_url || ''}
      placeholder='Variant URL'
      disabled={readOnly}
      onChange={e =>
        onChange(index, { variant_id: variant.variant_id, variant_url: e.target.value })
      }
    />
    {showDelete && (
      <IconButton
        onClick={e => {
          e.preventDefault();
          onDelete(index);
        }}
      >
        <MdDelete />
      </IconButton>
    )}
  </InputGroup>
);
